@if (contact) {
<form (ngSubmit)="save()" [formGroup]="form">
  <div class="flex items-center justify-between" mat-dialog-title>
    <div>
      @if (isUpdateMode() && canEdit()) {
      <h4 class="text-sm font-light">Editace kontaktu</h4>
      } @if (isUpdateMode() && !canEdit()) {
      <h4 class="text-sm font-light">Náhled kontaktu</h4>
      } @if (isUpdateMode()) {
      <h2 class="flex-auto m-0 headline">
        {{ contact.title }}
      </h2>
      } @if (isCreateMode()) {
      <h2 class="flex-auto m-0 headline">Nový kontakt</h2>
      }
    </div>
  </div>

  <mat-divider class="text-border"></mat-divider>

  <mat-dialog-content class="flex flex-col">
    <div class="flex w-full space-x-4">
      <mat-form-field class="w-2/3">
        <mat-label>Název/Celé jméno</mat-label>
        <input formControlName="title" matInput />
        <mat-icon matPrefix svgIcon="mat:perm_identity"></mat-icon>
      </mat-form-field>
      <mat-form-field class="w-1/6">
        <mat-label>Typ kontaktu</mat-label>
        <mat-select formControlName="contactTypeId">
          @for (ct of contactTypes; track ct) {
          <mat-option [value]="ct.id">{{ ct.title }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field class="w-1/6">
        <mat-label>Role</mat-label>
        <mat-select #select formControlName="roles" multiple>
          @for (role of contactRoles; track role) {
          <mat-option [value]="role.id">{{ role.langs[0].name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <div class="flex w-full space-x-4">
      <mat-form-field class="w-1/2">
        <mat-label>Jméno</mat-label>
        <input formControlName="firstName" matInput />
        <mat-icon matPrefix svgIcon="mat:perm_identity"></mat-icon>
      </mat-form-field>
      <mat-form-field class="w-1/2">
        <mat-label>Příjmení</mat-label>
        <input formControlName="lastName" matInput />
        <mat-icon matPrefix svgIcon="mat:perm_identity"></mat-icon>
      </mat-form-field>
    </div>
    <mat-form-field>
      <mat-label>Název společnosti</mat-label>
      <input formControlName="companyName" matInput />
      <mat-icon matPrefix svgIcon="mat:perm_identity"></mat-icon>
    </mat-form-field>
    <div class="flex flex-col mb-2">
      <div class="flex items-center -mb-0.5 ml-2">
        <mat-icon class="mr-2" matPrefix svgIcon="mat:lock"></mat-icon>
        <h2 class="font-semibold">Interní poznámky</h2>
      </div>
      <div>
        <editor
          [init]="tinyService.modulesEasy()"
          class="w-full"
          formControlName="notesInternal"
        >
        </editor>
      </div>
    </div>
    <div class="flex justify-between w-full mb-4">
      <div class="flex items-center space-x-2">
        <mat-label class="font-semibold">Pro veřejnost</mat-label
        ><mat-icon
          svgIcon="mat:info"
          matTooltip="Určuje, zda kontakt bude propsán do veřejného soupisu nebo pouze označen typem ('soukromá osoba apod.')"
        ></mat-icon>
      </div>
      <mat-slide-toggle formControlName="isPublic"> </mat-slide-toggle>
    </div>
    @if (isEditorContext()) {
    <div class="flex justify-between w-full mb-4">
      <div class="flex items-center space-x-2">
        <mat-label class="font-semibold">Globální</mat-label
        ><mat-icon
          svgIcon="mat:info"
          matTooltip="Určuje, zda je kontakt viditelný ve všech soupisech"
        ></mat-icon>
      </div>
      <mat-slide-toggle formControlName="curated"> </mat-slide-toggle>
    </div>
    }
  </mat-dialog-content>
  @if (canEdit()) {
  <mat-divider class="text-border"></mat-divider>
  } @if (canEdit()) {
  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close type="button">Zrušit</button>
    <button
      color="primary"
      mat-flat-button
      type="submit"
      [disabled]="form.invalid"
    >
      {{ isCreateMode() ? "Vytvořit" : "Aktualizovat" }}
    </button>
  </mat-dialog-actions>
  }
</form>
}
